var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeatureIconOrganiser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4239_195)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 44,
    fill: "#E0F2FE"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4239_195)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 44,
    r: 32,
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41 42H34C33.7348 42 33.4804 41.8946 33.2929 41.7071C33.1054 41.5196 33 41.2652 33 41V34C33 33.7348 33.1054 33.4804 33.2929 33.2929C33.4804 33.1054 33.7348 33 34 33H41C41.2652 33 41.5196 33.1054 41.7071 33.2929C41.8946 33.4804 42 33.7348 42 34V41C42 41.2652 41.8946 41.5196 41.7071 41.7071C41.5196 41.8946 41.2652 42 41 42Z",
    fill: "#0876DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 55H34C33.7348 55 33.4804 54.8946 33.2929 54.7071C33.1054 54.5196 33 54.2652 33 54V47C33 46.7348 33.1054 46.4804 33.2929 46.2929C33.4804 46.1054 33.7348 46 34 46H41C41.2652 46 41.5196 46.1054 41.7071 46.2929C41.8946 46.4804 42 46.7348 42 47V54C42 54.2652 41.8946 54.5196 41.7071 54.7071C41.5196 54.8946 41.2652 55 41 55Z",
    fill: "#0876DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 34H55V36H45V34Z",
    fill: "#0876DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55 47H45V49H55V47Z",
    fill: "#0876DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55 52H45V54H55V52Z",
    fill: "#0876DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55 39H45V41H55V39Z",
    fill: "#0876DD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4239_195",
    x: -8,
    y: 2,
    width: 104,
    height: 104,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.109804 0 0 0 0 0.172549 0 0 0 0 0.25098 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4239_195"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4239_195",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4239_195"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureIconOrganiser);
export default __webpack_public_path__ + "static/media/feature-icon-organiser.0dfafdadde4d553225839397467c3ab7.svg";
export { ForwardRef as ReactComponent };